import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/configuracion-de-nombramientos';

/**
 * GET Configuraciones de Nombramientos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getConfiguracionesNombramientos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Configuracion de Nombramiento
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getConfiguracionNombramiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Configuracion de Nombramiento
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionNombramiento = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configuracion de Nombramiento
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguracionNombramiento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Configuracion de Nombramiento
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteConfiguracionNombramiento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Configuracion de Nombramiento
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarConfiguracionNombramiento = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
